module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container g-py-40",
    attrs: {
      "id": "contactDiv"
    }
  }, [_vm._m(0), _vm._v(" "), _c('jotform-embed', {
    attrs: {
      "jotFormID": "220555106034141"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "text-center g-mb-50"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Contact Us")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Have a question or concern?  Please fill out the form below and we’ll get back to you soon.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-97924f2c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97924f2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/HelpContact.vue
// module id = 552
// module chunks = 4